import {BNPL_BREAKPOINT_LG, BNPL_WIDGET_STYLE} from '@amblique/king-living/app/constants/bnpl-messaging';
import {A11Y_FOCUS_VISIBLE} from '@amblique/king-living/app/theme/foundations/a11y-focus-visible';

const {AFTERPAY_LOGO_BADGE_WIDTH, FONT_SIZE, INFO_ICON_SIZE, LOGO_HEIGHT} = BNPL_WIDGET_STYLE;

// Shared per-provider row style — keep Afterpay and Zip identical.
const widgetRow = {
  alignItems: 'center',
  color: 'greyscale.100',
  display: 'flex',
  fontFamily: 'body',
  fontSize: FONT_SIZE,
  fontWeight: 'normal',
  lineHeight: '120%',
  minHeight: LOGO_HEIGHT,
  width: '100%',
  sx: {
    '.cart-flyout__footer &': {
      justifyContent: {'base': 'center', 'lg': 'flex-start'},
    }
  },

};

const BuyNowPayLaterMessaging = {
  parts: ['root', 'afterpayWidget', 'zipWidget'],
  baseStyle: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      width: '100%',
      textAlign: 'center',
    },
    afterpayWidget: {
      ...widgetRow,
      '& square-placement': {
        '--logo-badge-width': AFTERPAY_LOGO_BADGE_WIDTH,
        '--messaging-font-size': FONT_SIZE.base,
        alignItems: 'center',
        display: 'inline-flex',
        lineHeight: '120%',
        [`@media (min-width: ${BNPL_BREAKPOINT_LG})`]: {
          '--messaging-font-size': FONT_SIZE.lg,
        },
        '.cart-flyout__footer &': {
          marginTop: '-4px',
          marginBottom: '4px',
          marginLeft: {'base': 'auto', 'lg': '0'},
          marginRight: {'base': 'auto', 'lg': '0'},
        },
      },
    },
    zipWidget: {
      ...widgetRow,
      '& .zip-widget__wrapper': {
        padding: 0,
        '.cart-flyout__footer &': {
          marginLeft: {'base': 'auto', 'lg': '0'},
          marginRight: {'base': 'auto', 'lg': '0'},
        }
      },
      '& .zip-container': {
        alignItems: 'center',
        display: 'inline-flex',
        flexWrap: 'wrap',
        gap: '2px',
        lineHeight: '120%',
        margin: 0,
      },
      '& .zip-container span': {
        fontSize: FONT_SIZE,
        margin: 0,
      },
      '& .zip-container img': {
        height: INFO_ICON_SIZE,
        margin: 0,
        verticalAlign: 'middle',
        width: INFO_ICON_SIZE,
      },
      '& .zip-container img.zip-logo': {
        height: LOGO_HEIGHT,
        margin: '0 0 0 2px',
        maxHeight: LOGO_HEIGHT,
        verticalAlign: 'middle',
        width: 'auto',
      },
      '& .zip-container svg': {
        height: INFO_ICON_SIZE,
        margin: 0,
        verticalAlign: 'middle',
        width: INFO_ICON_SIZE,
      },
      '& .kl-zip-info-a11y-button': {
        alignItems: 'center',
        background: 'transparent',
        border: 0,
        color: 'inherit',
        cursor: 'pointer',
        display: 'inline-flex',
        font: 'inherit',
        height: LOGO_HEIGHT,
        justifyContent: 'center',
        lineHeight: 1,
        margin: 0,
        padding: 0,
        verticalAlign: 'middle',
        fontSize: FONT_SIZE,
      },
      '& [data-kl-a11y-enhanced="true"]': A11Y_FOCUS_VISIBLE,
    },
  },
};

export default BuyNowPayLaterMessaging;
